import { render, staticRenderFns } from "./FirmGroupBasedata.vue?vue&type=template&id=422d712a"
import script from "./FirmGroupBasedata.vue?vue&type=script&lang=js"
export * from "./FirmGroupBasedata.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports